function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/require-default-props */
import React from 'react';
import Select, { components } from 'react-select';
import { func, instanceOf, string } from 'prop-types'; // components

import Icons from '../icons/collection'; // styles

import { DateNoDropdown, SelectDropDownWrapper } from './styled/styles'; // utils

import { DateFormatHandler } from '../utils/dateFormat';
var today = new Date();
var tomorrow = new Date(today);
tomorrow.setDate(tomorrow.getDate() + 1);
today = DateFormatHandler(today, 'date');
tomorrow = DateFormatHandler(tomorrow, 'date');
var optionWrapperStyle = {
  display: 'flex',
  placeItems: 'center',
  fontWeight: '600',
  fontSize: '16px'
};

var SingleValue = function SingleValue(props) {
  var _props$data, _props$data2, _props$data3;

  return /*#__PURE__*/React.createElement(components.SingleValue, _extends({}, props, {
    "data-test-id": "scl-option"
  }), /*#__PURE__*/React.createElement("span", {
    className: "drop-label",
    style: optionWrapperStyle,
    "data-test-id": "select-output"
  }, /*#__PURE__*/React.createElement(Icons.Calendar, {
    height: "14",
    width: "14",
    style: {
      paddingRight: '10px'
    }
  }), today === ((_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.label) && 'Today, ', tomorrow === (props === null || props === void 0 ? void 0 : (_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.label) && 'Tomorrow, ', (_props$data3 = props.data) === null || _props$data3 === void 0 ? void 0 : _props$data3.label));
};

var Option = function Option(props) {
  return /*#__PURE__*/React.createElement("div", {
    "data-test-id": "scl-option"
  }, /*#__PURE__*/React.createElement(components.Option, props, today === (props === null || props === void 0 ? void 0 : props.label) && /*#__PURE__*/React.createElement("span", {
    className: "drop-label"
  }, "Today,", ' ', props === null || props === void 0 ? void 0 : props.label), tomorrow === (props === null || props === void 0 ? void 0 : props.label) && /*#__PURE__*/React.createElement("span", {
    className: "drop-label"
  }, "Tomorrow,", ' ', props.label), today !== (props === null || props === void 0 ? void 0 : props.label) && tomorrow !== (props === null || props === void 0 ? void 0 : props.label) && /*#__PURE__*/React.createElement("span", {
    className: "drop-label"
  }, props.label)));
};

var TimeSlotDropdown = function TimeSlotDropdown(_ref) {
  var dataAnalyticsLabel = _ref.dataAnalyticsLabel,
      dates = _ref.dates,
      _onChange = _ref.onChange;
  var customStyles = {
    option: function option(base, _ref2) {
      var isFocused = _ref2.isFocused,
          isSelected = _ref2.isSelected;
      return _objectSpread(_objectSpread({}, base), {}, {
        textAlign: 'left',
        padding: '5px 0 5px 18px',
        display: 'flex',
        placeItems: 'center',
        alignItems: 'center',
        color: '#42484D',
        height: 'auto',
        backgroundColor: isSelected ? 'transparent' : isFocused ? '#F2F2F2' : null,
        cursor: 'pointer'
      });
    },
    menu: function menu(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        margin: 0,
        padding: 0,
        border: '1px solid #CFD8DC',
        overflow: 'hidden',
        height: 'auto',
        borderRadius: '0 0 5px 5px',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.1)',
        zIndex: '100',
        div: {
          padding: '5px auto'
        }
      });
    },
    menuPortal: function menuPortal(base) {
      return _objectSpread({}, base);
    },
    control: function control(base, _ref3) {
      var isFocused = _ref3.isFocused;
      return _objectSpread(_objectSpread({}, base), {}, {
        padding: '10px 20px',
        border: isFocused ? '1px solid #CFD8DC' : null,
        borderRadius: isFocused ? '5px 5px 0 0' : '5px',
        boxShadow: isFocused ? '0 0 0px #CFD8DC' : null,
        height: 'auto',
        maxHeight: '60px',
        ':hover': {
          border: '1px solid #CFD8DC'
        },
        div: {
          color: '#42484D'
        }
      });
    },
    indicatorsContainer: function indicatorsContainer(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        height: 'auto',
        span: {
          backgroundColor: 'transparent'
        }
      });
    },
    dropdownIndicator: function dropdownIndicator(base, _ref4) {
      var isFocused = _ref4.isFocused;
      return _objectSpread(_objectSpread({}, base), {}, {
        height: 'auto',
        color: isFocused ? '#42484d' : 'inherit',
        ':hover': {
          color: '#42484d'
        }
      });
    }
  };
  var options = dates && dates.map(function (date) {
    return {
      label: date,
      value: date
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, (dates === null || dates === void 0 ? void 0 : dates.length) > 1 && /*#__PURE__*/React.createElement(SelectDropDownWrapper, {
    className: "selector basic-multi-select",
    "data-test-id": "time-slot-dropdown"
  }, /*#__PURE__*/React.createElement(Select, {
    className: "select",
    inputId: "scl-select-calendar",
    menuPortalTarget: global.document.body,
    styles: customStyles,
    components: {
      Option: Option,
      SingleValue: SingleValue
    },
    defaultValue: {
      value: options[0].value,
      label: options[0].label
    },
    dataAnalyticsLabel: dataAnalyticsLabel,
    value: options.value,
    options: options,
    onChange: function onChange(e) {
      return _onChange(e.value);
    },
    blurInputOnSelect: false,
    classNamePrefix: "select",
    placeholder: options[0].value,
    isSearchable: false
  })), (dates === null || dates === void 0 ? void 0 : dates.length) === 1 && /*#__PURE__*/React.createElement(DateNoDropdown, null, /*#__PURE__*/React.createElement(Icons.Calendar, {
    height: "14",
    width: "14",
    style: {
      padding: 0,
      paddingRight: '10px',
      marginBottom: '3px'
    }
  }), /*#__PURE__*/React.createElement("span", {
    value: dates,
    key: dates,
    "data-test-id": "select-span",
    className: "drop-span"
  }, today === (dates === null || dates === void 0 ? void 0 : dates.toString()) && "Today, ".concat(dates), tomorrow === (dates === null || dates === void 0 ? void 0 : dates.toString()) && "Tomorrow, ".concat(dates), today !== (dates === null || dates === void 0 ? void 0 : dates.toString()) && tomorrow !== (dates === null || dates === void 0 ? void 0 : dates.toString()) && dates)));
};

TimeSlotDropdown.propTypes = {
  /**
   * Define data analytics label
   */
  dataAnalyticsLabel: string,

  /**
  Everything included between opening and closing tags when invoking component
  */
  dates: instanceOf(Array),

  /**
  Change handler to pass back value of selected option
  */
  onChange: func
};
export default TimeSlotDropdown;